export enum ASSET_TYPES {
  ROAD = 'road',
  CULVERT = 'culvert',
  SIGN = 'sign',
  CATTLEGUARD = 'cattleguard',
  RESTAREA = 'restarea',
  STRUCTURE = 'structure'
}

export const ASSET_TYPE_LABELS = {
  [ASSET_TYPES.ROAD]: 'Road',
  [ASSET_TYPES.CULVERT]: 'Culvert',
  [ASSET_TYPES.SIGN]: 'Sign',
  [ASSET_TYPES.CATTLEGUARD]: 'Cattleguard',
  [ASSET_TYPES.RESTAREA]: 'Rest Area',
  [ASSET_TYPES.STRUCTURE]: 'Structure'
};

/**
 * Asset types offered when filtering Work IDs. Deliberately a two-option subset rather than the
 * full ASSET_TYPES list, and deliberately a type filter rather than a picker of individual assets:
 * the control it replaces listed every asset in a service area and was disabled until one was set.
 */
export const ASSET_TYPE_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: ASSET_TYPES.ROAD, label: 'Road Assets' },
  { value: ASSET_TYPES.STRUCTURE, label: 'Structure Assets' }
];

